<template>
	<div>
		<div class="flying-button-wrapper w-limit context-menu"
		     v-on:click.self="onDropdownHide"
		     @hide="onDropdownHide"
		>
			<div class="flying-inside dropup"
			     v-on:click.self="onDropdownHide"
			     @hide="onDropdownHide"
			>
				<a class="flying-button offanimation" data-toggle="dropdown" data-display="static"></a>
				<div class="dropdown-menu"
				     v-on:click.self="onDropdownHide"
				     @hide="onDropdownHide"
				>
					<a class="dropdown-item tambah-layanan-onboarding offanimation" @click="action" v-if="showAdd">
						<div class="icon-prefix" style="background-image: url('../../../assets/icons/plus1.svg')">
						</div>
						Tambah Baru {{ context }}
					</a>
					<a class="dropdown-item" @click="importData">
						<div class="icon-prefix" style="background-image: url('../../../assets/icons/upload.svg')">
						</div>
						Impor Data {{ (showContext) ? context : '' }}
					</a>
					<a class="dropdown-item" @click="exportData">
						<div class="icon-prefix"
						     style="background-image: url('../../../assets/icons/upload(1).svg')"></div>
						Ekspor Data {{ (showContext) ? context : '' }}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOFABMenu",
	props: {
		context: String,
		showContext: Boolean,
	},
	methods: {
		action() {
			this.$emit("action")
			this.smartTrackingClick("add_konsumen_reguler");

		},
		importData() {
			this.$emit("import")
			this.smartTrackingClick("import_konsumen_reguler");
		},
		exportData() {
			this.$emit("export")
			this.smartTrackingClick("export_konsumen_reguler");
		},
		onDropdownHide(bvEvent) {
			bvEvent.preventDefault();
		},
	},
	computed: {
		showAdd() {
			let show = true
			switch (this.context) {
				case 'Konsumen':
					show = this.validateAccess('customerRegular.create')
					break;
				default:
					break;
			}
			return show
		}
	}
}
</script>